// REQUESTED_RETAIL_SCOPES (and the READ/UPDATE/DELETE_CLIENTS scopes) have been
// promoted to @invivodf/front-seller-auth as part of the b2ag/retail front merge
// (Phase 0). This temporary re-export keeps existing retail consumers working;
// remove it once they import from the package directly.
export * from '@invivodf/front-seller-auth/src/REQUESTED_RETAIL_SCOPES'
